<!-- 用户协议 -->
<template>
  <div class="mainBox" id="withdrawal">
    <!-- header start -->
    <van-nav-bar
      title="提现"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->
    <div class="bodyBox">
      <div class="select-card" v-if="bankList != null" @click="selectBank">
        <div class="select-card-left" v-if="bankList.length > 0">
          <div class="select-card-left-titie">提现至：</div>
          <div class="select-card-left-val">
            <div>
              <!-- <img src="~@/assets/image/ka.png" alt="" /> -->
              {{ radioGroup == "0" ? "选择提现账户" : selectName }}
            </div>
            <!-- <div><img src="~@/assets/image/zhifubao.png" alt="">支付宝</div> -->
          </div>
        </div>
        <div class="select-card-left" v-else>
          <div class="select-card-left-titie">添加银行卡</div>
        </div>

        <van-icon name="arrow" />
      </div>
      <div class="money-box" v-if="User != null">
        <div class="money-box-left">余额(元)</div>
        <div class="money-box-right">
          {{ User.HasPrice - User.FrozenPrice }}
        </div>
      </div>
      <div class="input-box">
        <div class="input-box-title flexbox">
          <div class="flexmid">提现金额</div>
          <router-link to="/WithdrawalList" class="hlight"
            >提现明细</router-link
          >
        </div>

        <div class="input-box-input">
          <div>￥</div>
          <input
            type="text"
            v-model="inputVal"
            pattern="number"
            oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')}"
          />
        </div>
      </div>
      <div class="withdrawal-btn" @click="OnAdd" tapmode>立即提现</div>
      <div class="matter-box">
        <div class="matter-box-title">*注：提现说明</div>
        <div class="matter-box-text">
          <div>1、最低提现100元起提</div>
          <div>
            2、银行卡、支付宝提现手续费5%，到账时间为2-24小时之内
          </div>
          <div>3、提现金额必须为大于等于100！</div>
        </div>
      </div>
    </div>

    <!-- 选择提现地址 -->
    <van-action-sheet
      v-model="selectShow"
      title="选择提现方式"
      :closeable="false"
    >
      <div class="select-method-box">
        <van-radio-group v-model="radioGroup">
          <div
            class="every-method"
            v-for="(item, index) in bankList"
            :key="index"
            @click="changeBank(item.SerialNumber)"
          >
            <div v-if="item.AlipayAccount == null" class="every-method-left">
              <img src="~@/assets/images/ka.png" alt="" />
              <span
                >{{ item.CollectionBrankName }}({{
                  item.CollectionNumber
                }})</span
              >
            </div>
            <div class="every-method-left" v-else>
              <img src="~@/assets/images/zhifubao.png" alt="" />
              <span>支付宝({{ item.AlipayAccount }})</span>
            </div>
            <div class="every-method-right">
              <van-radio
                :name="item.SerialNumber"
                checked-color="#FF669E"
              ></van-radio>
            </div>
          </div>
          <!-- <div
            class="every-method"
            @click="radioClick('支付宝' + alipay.four, '2')"
          >
            <div class="every-method-left">
              <img src="~@/assets/image/zhifubao.png" alt="" />
              <span>支付宝({{ alipay.four }})</span>
            </div>
            <div class="every-method-right">
              <van-radio name="2" checked-color="#FF669E"></van-radio>
            </div>
          </div> -->
        </van-radio-group>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from "vant";
import common from "../../../tools/common";
import { Toast } from "vant";

export default {
  data() {
    return {
      selectShow: false, //显示提现到账弹窗
      radioGroup: "0", //选择方式
      selectName: "",
      bankList: null,
      cashSet: {},
      inputVal: "",
      User: null,
      bankModel: null,
    };
  },
  components: {
    [ActionSheet.name]: ActionSheet,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetBankList",
        })
        .then((res) => {
          common.Response.callNotMsgResponse(res, (result) => {
            //console.log(result);
            that.bankList = result.data;
          });
        });

      this.$store
        .dispatch({
          type: "GetUser",
        })
        .then((res) => {
          common.Response.callNotMsgResponse(res, (result) => {
            //console.log(result,"callNotMsgResponse");
            that.User = result;
          });
        });
    },
    selectBank() {
      if (this.bankList.length > 0) {
        this.selectShow = true;
      } else {
        this.$router.push("/accountManage");
      }
    },
    changeBank(id) {
      var _findData = this.bankList.filter((x) => x.SerialNumber == id)[0];
      //console.log(_findData);
      this.radioGroup = id;
      if (_findData.AlipayAccount != null) {
        this.selectName = _findData.AlipayAccount;
      } else {
        this.selectName =
          _findData.CollectionBrankName + "-" + _findData.CollectionNumber;
      }
      this.bankModel = _findData;
      this.selectShow = false;
    },
    OnAdd() {
      var that = this;
      if (this.bankModel == null) {
        Toast("没有选择你要提现银行卡！");
        return false;
      }
      if (this.inputVal == "") {
        Toast("必须输入金额！");
        return false;
      }

      if (parseInt(this.inputVal) < 100) {
        Toast("金额必须大于等于100");
        return false;
      }

      //console.log(this.bankModel, "bankModel");

      var _isAlipay = this.bankModel.AlipayAccount == null ? false : true;
      
      var _options = {
        type: "PostTransactionDetailApply",
        price: this.inputVal,
        bankTypeId: !_isAlipay ? 1 : 2,
        CollectionName: !_isAlipay
          ? this.bankModel.CollectionAccount
          : this.bankModel.RealName,
        CollectionBrankName: !_isAlipay
          ? this.bankModel.CollectionBrankName
          : "支付宝",
        CollectionNumber: !_isAlipay
          ? this.bankModel.CollectionNumber
          : this.bankModel.AlipayAccount,
      };

      this.$store.dispatch(_options).then((res) => {
        common.Response.CallResponse(res, (result) => {
          that.inputVal = 0;
          setTimeout(function() {
            that.init();
          }, 2000);
        });
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
html,
body {
  background-color: #f7f6fb;
}
.header {
  width: 100%;
  background-color: #fff;
  position: relative;
}
.header-text {
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
  // font-size: 0.76rem;
  color: #333;
}
.backBox {
  position: absolute;
  width: 0.71rem;
  left: 0.619rem;
  line-height: 2.5rem;
}
.backBox > img {
  width: 0.38rem;
}

/*内容*/
.bodyBox {
  width: 100%;
  height: auto;
  padding-bottom: 1rem;
}

.select-card {
  width: 100%;
  height: 2.28rem;
  background-color: #fff;
  margin-top: 0.38rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 0.52rem;
}

.select-card .van-icon {
  // font-size: 0.71rem;
  color: #999999;
}

.select-card-left {
  display: flex;
  align-items: center;
}

.select-card-left-titie {
  // font-size: 0.619rem;
  color: #333333;
}
.select-card-left-val > div {
  display: flex;
  align-items: center;
  // font-size: 0.619rem;
  color: #333333;
}
.select-card-left-val > div > img {
  width: 0.8rem;
  display: block;
  margin-left: 0.33rem;
  margin-right: 0.33rem;
}

.money-box {
  width: 100%;
  height: 2.28rem;
  margin-top: 0.38rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 0.52rem;
  background-color: #fff;
}

.money-box-left {
  // font-size: 0.71rem;
  color: #666666;
}

.money-box-right {
  // font-size: 0.8rem;
  color: #333333;
}

.input-box {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 1.05rem 0.67rem;
  margin-top: 0.38rem;
}

.input-box-title {
  width: 100%;
  height: auto;
  // font-size: 0.56rem;
  color: #333;
}

.input-box-input {
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin-top: 1.4rem;
}

.input-box-input div {
  // font-size: 1.33rem;
  color: #333333;
  font-weight: bold;
}
.input-box-input input {
  width: 100%;
  height: auto;
  // font-size: 1.33rem;
  color: #333333;
  padding-left: 1rem;
  font-weight: bold;
  padding-bottom: 0.1rem;
}

.withdrawal-btn {
  width: 76%;
  height: 2.3rem;
  border-radius: 90px;
  background-color: #24a378;
  // font-size: 0.8rem;
  color: #ffffff;
  margin: auto;
  margin-top: 2rem;
  text-align: center;
  line-height: 2.3rem;
}

.matter-box {
  width: 100%;
  height: auto;
  padding: 0rem 1.3rem;
  margin-top: 2.3rem;
}

.matter-box-title {
  width: 100%;
  height: auto;
  // font-size: 0.619rem;
  color: #333333;
}

.matter-box-text {
  width: 100%;
  height: auto;
  margin-top: 0.38rem;
}

.matter-box-text > div {
  // font-size: 0.619rem;
  color: #333333;
  margin-bottom: 0.1rem;
}

/*弹窗*/
.select-method-box {
  width: 100%;
  height: auto;
  border-top: 0.05rem solid #f2f2f2;
  padding-bottom: 2rem;
}
.every-method {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 0.5rem 0.9rem 1.1rem;
}
.every-method-left {
  display: flex;
  align-items: center;
}

.every-method-left img {
  width: 1rem;
  display: block;
}

.every-method-left span {
  // font-size: 0.71rem;
  color: #333333;
  margin-left: 0.38rem;
}
</style>
